import { makeStyles, createStyles } from "@material-ui/styles"

const useStyles = makeStyles(theme =>
  createStyles({
    dialogContainer: {
      minWidth: "500px",
      [theme.breakpoints.down("sm")]: {
        minWidth: "100%",
      },
    },
    title: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "40px",
    },

    actions: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "stretch",
    },
    buttons: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      width: "90%",
      padding: "20px",
    },
  })
)

export default useStyles
